import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateEmail, useMediaQuery } from './shared-functions.js';
import { db } from "./use-firebase.js";
import { collection, addDoc } from 'firebase/firestore'; // getDocs, query, where
import { Row, Col, Button, Image, Card, Badge } from 'react-bootstrap';
import Footer from './components/common/Footer.js';
import Logo from "./components/common/Logo.js";
import { LockSimple, Money, SmileySticker } from "phosphor-react";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Home() {

  const navigate = useNavigate();
  let isPageWide = useMediaQuery('(min-width: 960px)');
  const [validated, setValidated] = useState(false);

  const doToastSuccess = (text) => {
    toast.success(text, {
      position: "top-right",
      theme: "light",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    })
  };

  const doToastError = (text) => {
    toast.error(text, {
      position: "top-right",
      theme: "light",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    })
  };

  return (
    <Row style={{ justifyContent: 'center', marginBottom: 100 }}>
      
    </Row>
  )

}
